/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Twda_Reason_No_RoundsInputs */



/**
* | output |
* | --- |
* | "the event was imported without its rounds" |
*
* @param {Twda_Reason_No_RoundsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const twda_reason_no_rounds = /** @type {((inputs?: Twda_Reason_No_RoundsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Twda_Reason_No_RoundsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ce tournoi a été importé sans ses rondes")
	if (locale === "es") return /** @type {LocalizedString} */ ("el torneo se importó sin sus rondas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("o torneio foi importado sem as suas rodadas")
	if (locale === "it") return /** @type {LocalizedString} */ ("il torneo è stato importato senza i suoi turni")
	return /** @type {LocalizedString} */ ("the event was imported without its rounds")
});